module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"fr":{"1":"Langue","2":"Niveau","3":"Ajouter une langue"},"en":{"1":"Language","2":"Level","3":"Add a language"}}')
  delete Component.options._Ctor
}
